export default {
  title: '异常管理中心',
  subtitle: '统一管理所有业务异常',
  tabs: { my: '我的异常', team: '团队全部', pending: '待分配' },
  actions: {
    search: '查询',
    reset: '重置',
    refresh: '刷新',
    manualCreate: '手动登记',
    detail: '查看',
    assign: '分配',
    start: '开始处理',
    append: '追加结果',
    resolve: '提交解决',
    verify: '关闭',
    return: '退回重处理',
    close: '关闭',
    confirm: '确认操作',
    cancel: '取消',
    save: '提交登记',
    searchObject: '搜索对象',
    batchAssign: '批量分配',
    config: '异常配置',
    process: '处理',
    submitResult: '提交结果',
    transfer: '转派',
    supplement: '补充',
    verifyPass: '复核通过',
    reject: '驳回',
    cancelSelection: '取消选择',
    confirmCreate: '确认登记'
  },
  summary: {
    todayCreated: '今日新增',
    pendingCount: '待处理',
    inProgressOverdue: '处理中超时',
    todayClosed: '今日已关闭'
  },
  filters: {
    keyword: '异常编号、标题或描述',
    status: '状态',
    objectType: '对象类型',
    category: '异常大类',
    subcategory: '异常小类',
    level: '异常等级',
    assignee: '负责人',
    triggeredStart: '触发开始时间',
    triggeredEnd: '触发结束时间',
    overdue: '是否超时',
    overdueYes: '已超时',
    overdueNo: '未超时',
    all: '全部'
  },
  objectTypes: { DISTRIBUTION_SHIPMENT: '发货申请单', TRANSPORT_CONSIGNMENT: '运输委托单', WAYBILL: '运单', FEE: '费用' },
  statuses: {
    PENDING_ASSIGN: '待分配',
    PENDING_PROCESS: '待处理',
    IN_PROGRESS: '处理中',
    RESOLVED: '已解决',
    CLOSED: '已关闭'
  },
  levels: { S1: 'S1 紧急', S2: 'S2 重要', S3: 'S3 一般' },
  table: {
    no: '异常编号',
    title: '异常标题',
    object: '业务对象',
    type: '异常类型',
    orderNo: '订单号',
    description: '异常描述',
    level: '等级',
    status: '状态',
    assignee: '负责人',
    triggeredAt: '触发时间',
    sla: 'SLA',
    overdue: '已超时',
    operation: '操作'
  },
  assignee: {
    inactive: '已停用用户',
    unresolved: '负责人信息待同步'
  },
  manual: {
    title: '手动登记异常信息',
    category: '异常大类',
    categoryPlaceholder: '选择大类',
    subcategory: '异常小类',
    subcategoryPlaceholder: '选择小类',
    level: '异常等级',
    levelPlaceholder: '选择等级',
    distributionShipment: '发货申请单号',
    distributionShipmentPlaceholder: '选择发货申请单',
    transportConsignment: '运输委托单号',
    transportConsignmentPlaceholder: '选择运输委托单',
    waybill: '运单号',
    waybillPlaceholder: '选择运单',
    feeName: '费用',
    feePlaceholder: '选择费用',
    feeSourceConsignment: '委托单：{value}',
    feeSourceWaybill: '运单：{value}',
    feeSourceDocument: '来源单号：{value}',
    feeSourceUnknown: '未关联运单/委托单',
    objectType: '关联对象类型',
    objectTypePlaceholder: '选择对象类型',
    objects: '订单号/关联业务对象',
    objectSearchPlaceholder: '按订单号或业务对象名称搜索',
    keyword: '订单号或业务对象名称',
    selected: '已选择 {count} 条',
    description: '异常描述',
    descriptionPlaceholder: '请描述异常的具体情况，最多500字',
    assignee: '负责人（可选）',
    assigneePlaceholder: '按用户名搜索负责人'
  },
  batch: {
    title: '批量分配负责人',
    selected: '已选择 {count} 项',
    assignee: '负责人',
    assigneePlaceholder: '按用户名搜索负责人'
  },
  detail: {
    manualAddition: '手动添加',
    title: '异常详情',
    base: '基本信息',
    objects: '关联实体',
    history: '处理历史',
    openObject: '查看业务对象',
    openDistributionShipment: '发货申请单详情',
    openConsignment: '委托单详情',
    openWaybill: '运踪详情',
    slaDeadline: 'SLA 截止',
    slaOverdue: '已超时',
    slaNormal: '未超时',
    systemOperator: '系统',
    operationContent: '处理说明',
    operationContentPlaceholder: '请描述处理过程和结果',
    rejectReason: '退回原因',
    rejectReasonPlaceholder: '请说明退回原因和要求',
    assignee: '负责人',
    assigneePlaceholder: '按用户名搜索负责人',
    fields: {
      distributionShipmentNo: '发货申请单号',
      transportConsignmentNo: '运输委托单号',
      waybillNo: '运单号',
      feeName: '费用名称',
      businessType: '业务类型',
      supplierName: '供应商',
      routeName: '航线',
      triggerCondition: '触发条件',
      triggeredAt: '触发时间',
      sourceRule: '来源规则',
      assignee: '负责人'
    },
    historyActions: {
      CREATE: '创建',
      ASSIGN: '分配负责人',
      REASSIGN: '重新分配',
      START: '开始处理',
      APPEND_RESULT: '补充处理结果',
      RESOLVE: '提交解决',
      VERIFY: '关闭',
      RETURN: '退回重处理',
      CLOSE: '关闭'
    },
    snapshot: {
      consignmentNo: '委托单号',
      blNo: '提单号',
      expressWaybillNo: '快递单号',
      mainStatus: '主状态',
      trackingNodeExpectedTime: '运踪节点预计时间',
      trackingNodeStatus: '运踪节点状态',
      voyageEtd: '航次 ETD',
      voyageEta: '航次 ETA',
      businessType: '业务类型',
      expectedCompleteTime: '预计完成时间',
      expectedShipTime: '预计发运时间',
      expectedArrivalTime: '预计到达时间',
      consignmentStatus: '委托状态',
      bookingStatus: '订舱状态',
      feeConfirmStatus: '费用确认状态',
      feeType: '费用类型',
      currency: '币种',
      amount: '含税金额',
      waybillNo: '所属运单号',
      dateCreated: '创建时间',
      writeOffDate: '核销日期',
      receiptPaymentDate: '收付款日期',
      invoiceDate: '发票日期',
      writeOffStatus: '核销状态',
      reconciliationStatus: '对账状态',
      estimatePushStatus: '预估推送状态',
      settlementPushStatus: '结算推送状态'
    }
  },
  basicData: {
    title: '基础数据',
    subtitle: '维护异常分类字典和异常级别',
    categoryTab: '异常分类',
    levelTab: '异常级别',
    categories: '异常大类',
    levels: '异常级别',
    subcategoryList: '{name} - 异常小类',
    levelList: '异常级别列表',
    subcategoryCount: '小类数',
    addCategory: '新增大类',
    addSubcategory: '新增小类',
    addLevel: '新增级别',
    editCategory: '编辑异常大类',
    editSubcategory: '编辑异常小类',
    editLevel: '编辑异常级别',
    selectCategory: '请在左侧选择一个大类',
    code: '编码',
    name: '名称',
    sort: '排序',
    severity: '严重程度',
    severityHelp: '数字越小越严重，用于排序',
    slaHours: 'SLA默认值(h)',
    slaHoursForm: 'SLA默认值（小时）',
    color: '颜色',
    displayColor: '显示颜色',
    enabled: '启用',
    disabled: '停用',
    status: '状态',
    categoryCode: '大类编码',
    categoryName: '大类名称',
    subcategoryCode: '小类编码',
    subcategoryName: '小类名称',
    levelCode: '级别编码',
    levelName: '级别名称',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    codeRequired: '请输入编码',
    nameRequired: '请输入名称',
    valueRequired: '请输入有效数值',
    categoryCodeRequired: '请输入大类编码',
    categoryNameRequired: '请输入大类名称',
    subcategoryCodeRequired: '请输入小类编码',
    subcategoryNameRequired: '请输入小类名称',
    levelCodeRequired: '请输入级别编码',
    levelNameRequired: '请输入级别名称',
    colorRequired: '请选择颜色',
    deleteTitle: '确认删除',
    deleteCategoryConfirm: '删除大类后将无法恢复，确定继续吗？',
    deleteSubcategoryConfirm: '删除小类后将无法恢复，确定继续吗？',
    deleteLevelConfirm: '删除级别后将无法恢复，确定继续吗？',
    loadFailed: '基础数据加载失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败'
  },
  rule: {
    title: '异常配置',
    subtitle: '配置异常等级的判定规则',
    back: '返回',
    create: '新增规则',
    createTitle: '新增等级判定规则',
    editTitle: '编辑等级判定规则',
    confirm: '确定',
    levelRuleEmpty: '暂无等级判定规则，点击“新增规则”创建',
    listTitle: '等级判定规则',
    priority: '优先级',
    priorityPlaceholder: '数字越小越优先',
    copy: '复制',
    copyName: '{name} - 副本',
    unassigned: '未指定',
    name: '规则名称',
    namePlaceholder: '如：严重延误升S1',
    applicableType: '适用类型',
    applicableCategory: '适用大类',
    applicableSubcategory: '适用小类',
    allTypes: '全部类型',
    allCategories: '全部大类',
    allSubcategories: '全部小类',
    selectCategoryFirst: '请先选择大类',
    levelPlaceholder: '请选择等级',
    resultLevel: '结果等级',
    deductScore: '扣分分数',
    deductScorePlaceholder: '匹配后扣除的分数',
    conditionOverview: '条件概览',
    conditionMode: '条件匹配模式',
    conditionModes: { ALL: '全部满足（AND）', ANY: '满足其一（OR）', NONE: '无条件' },
    conditionConnectors: { ALL: 'and', ANY: 'or' },
    conditionListAll: '判定条件（AND 逻辑 — 所有条件同时满足时触发）',
    conditionListAny: '判定条件（OR 逻辑 — 任一条件满足时触发）',
    addCondition: '添加条件',
    dimension: '维度',
    conditionValue: '值',
    conditionValueEnd: '结束值',
    selectValue: '选择',
    dimensions: { DELAY_HOURS: '延时时长', CUSTOMER_TIER: '客户等级', BUSINESS_TYPE: '业务类型' },
    conditionOperators: { GTE: '≥', GT: '>', EQ: '=', LT: '<', LTE: '≤', BETWEEN: 'between' },
    conditionValues: {
      CUSTOMER_TIER: { VIP: 'VIP', NORMAL: '普通' },
      BUSINESS_TYPE: { FCL: 'FCL', LCL: 'LCL', AIR: 'AIR', RAIL: '铁路' }
    },
    operator: '比较方式',
    owner: '负责人',
    owners: '负责人（多选）',
    assigneePlaceholder: '按用户名搜索负责人',
    enabled: '启用',
    deleteConfirm: '确定删除规则“{name}”吗？'
  },
  messages: {
    loadFailed: '异常列表加载失败',
    summaryLoadFailed: '异常摘要加载失败',
    basicDataLoadFailed: '异常基础数据加载失败',
    teamMemberLoadFailed: '负责人候选人加载失败',
    detailFailed: '异常详情加载失败',
    detailVersionConflict: '异常状态已更新，详情已刷新，请重新操作',
    objectSearchFailed: '业务对象搜索失败',
    createSuccess: '异常登记成功',
    batchAssignSuccess: '批量分配完成，共成功 {successCount} 条',
    batchAssignPartial: '批量分配完成：成功 {successCount} 条，失败 {failedCount} 条{errorCodes}',
    batchAssignErrorCodes: '，错误码：{errorCodes}',
    operationSuccess: '操作成功',
    assignSuccess: '分配成功',
    startSuccess: '已开始处理',
    appendSuccess: '处理结果已补充更新',
    resolveSuccess: '处理结果已提交',
    verifySuccess: '复核通过，异常已关闭',
    returnSuccess: '已驳回，退回处理中',
    closeSuccess: '异常已关闭',
    operationFailed: '操作失败',
    selectObject: '请选择至少一个业务对象',
    selectPrimaryObject: '请至少选择发货申请单、运输委托单或运单中的一项',
    selectException: '请选择至少一条异常',
    descriptionRequired: '请输入异常描述',
    assigneeRequired: '请选择负责人',
    contentRequired: '请输入处理说明',
    manualBasicDataLoadFailed: '异常分类和等级加载失败，请稍后重试',
    manualBasicDataRequired: '请选择有效的启用分类、小类和等级',
    ruleSaveSuccess: '异常规则保存成功',
    ruleDeleteSuccess: '异常规则删除成功',
    levelRuleFormRequired: '请完整填写有效的等级判定规则'
  }
}
